import { useCallback, useEffect, useState } from 'react';
import { SelectProperty as SelectProp } from '../../peregrineFlowInterfaces';
import { NodePropertyProp } from '../NodePropertyPane';
import { FormControl, MenuItem, Select, SelectChangeEvent, Box, Typography, Tooltip } from '@mui/material';
import { HelpOutline } from '@mui/icons-material';

function SelectProperty({ property, onChange }: NodePropertyProp) {
    const p = property as unknown as SelectProp;
    const [value, setValue] = useState<string>(p.value);

    useEffect(() => {
        setValue(p.value)
    }, [p])

    const onValueChange = useCallback((event: SelectChangeEvent<string>) => {
        p.value = event.target.value;
        onChange?.(p);
        setValue(p.value);
    }, [p, onChange]);

    return (
        <Box sx={{ width: '100%' }}>
            <Box display="flex" alignItems="center">
                <Typography variant="caption">{p.label}</Typography>
                {p.description && (
                    <Tooltip title={<div style={{ whiteSpace: 'pre-line' }}>{p.description}</div>} componentsProps={{ tooltip: { sx: { maxWidth: 'none' } } }}>
                        <HelpOutline fontSize="small" sx={{ ml: 1, color: 'text.secondary', cursor: 'help', width: 16, height: 16 }} />
                    </Tooltip>
                )}
            </Box>
            <FormControl fullWidth>
                <Select
                    value={value}
                    onChange={onValueChange}
                >
                    {p.values.map((v) => {
                        return (
                            <MenuItem key={v} value={v}>{v}</MenuItem>
                        )
                    })}
                </Select>
            </FormControl>
        </Box>
    )
}

export default SelectProperty;
